var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFinishedStatus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 15.5C28 22.4036 22.4036 28 15.5 28C8.59644 28 3 22.4036 3 15.5C3 8.59644 8.59644 3 15.5 3C19.2984 3 22.7012 4.69425 24.9937 7.36827L16.1112 17.7284L11.1142 12.1849C10.5595 11.5696 9.61101 11.5204 8.99569 12.0751C8.38036 12.6297 8.33119 13.5782 8.88586 14.1935L15.0253 21.0044C15.3141 21.3247 15.7268 21.5053 16.1581 21.4999C16.5894 21.4946 16.9975 21.3038 17.2782 20.9764L26.7138 9.97105C27.5373 11.638 28 13.515 28 15.5ZM28.8008 7.53689C30.1972 9.86423 31 12.5884 31 15.5C31 24.0604 24.0604 31 15.5 31C6.93959 31 0 24.0604 0 15.5C0 6.93959 6.93959 0 15.5 0C20.0433 0 24.13 1.9547 26.965 5.06899L27.8613 4.02369C28.4005 3.39477 29.3474 3.32205 29.9763 3.86127C30.6053 4.40049 30.678 5.34744 30.1388 5.97636L28.8008 7.53689Z",
    fill: "#0170B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinishedStatus);
export default __webpack_public_path__ + "static/media/FinishedStatus.011154a5c5f594bddcfb766746174b7c.svg";
export { ForwardRef as ReactComponent };